@if (_active) {
  <kendo-window (keydown.enter)="$event.preventDefault()"
    #grid
    title="{{ _pageState == 2 ? 'ADD NEW RECORD' : _pageState == 3 ? 'EDIT RECORD' : _pageState == 1 ? 'VIEW RECORD' : _pageState == 4 ? 'EDIT FIELDS MODE' : '' }}"
    (close)="_onCancel()" (stateChange)="_onStateChanges($event)"
    class="fullWidthFormForm"
    [class.editFieldsModeClass]="_pageState == 4"
    [class.disabledPopup]="_editFormActive || _orderingTabsForm || _deactivatedFieldsForm"
    (keydown.enter)="$event.preventDefault()">
    <form novalidate [formGroup]="_form" (keydown.enter)="$event.preventDefault()" class="form_style">
      <div class="row special_row_margin">
        <div class="col-12 special_col_padding">
          <div class="border_sections margin-top-4">
            <!-- Main Popup Actions and Title -->
            <div class="row">
              <div class="col-12">
                <h2 class="formsTitle">
                  Condition
                  @if (canAccess(_permissionScope, 'update')) {
                    <span
                      (click)="_edit()"
                      [class.ViewModeVisibleElement]="_pageState == 1"
                      class="action-button action-button-viewMode">
                      <div class="action-button-icon">
                        <img [src]="'/assets/menu/'+ _theme +'/edit-action-icon-grid.svg'" />
                      </div>
                      <div class="edit-icon-text">Edit</div>
                    </span>
                  }
                </h2>
                <div class="upsert-header-buttons">
                  <ul class="menuButtonsList">
                    @if (canAccess(_permissionScope, 'update') && _currentUser.appRole.id!=3 && _currentUser.appRole.id!=4) {
                      <li
                        (click)="_onEditForms()"
                        [class.ViewModelHiddenElement]="_pageState != 2">
                        Edit Forms
                      </li>
                    }
                    @if (_currentUser.appRole.id!=3 && _currentUser.appRole.id!=4) {
                      <li
                        class="wikiButton"
                        (click)="_onEditFields()"
                        [class.ViewModeHiddenElement]="_pageState != 2">
                        Edit Fields
                      </li>
                    }
                    <li class="wikiButton"
                      (click)="_returnAdNew()"
                      [class.ViewModeHiddenElement]="_pageState != 4">
                      Close Edit Fields
                    </li>
                    <!-- <li class="wikiButton">Wiki</li> [class.disabled]="_deactivatedFieldsGridData?.length == 0"-->
                    @if (_pageState == 2) {
                      <li
                        class="wikiButton"
                        (click)="_viewInactiveFields()">
                        View Inactive Fields
                      </li>
                    }
                  </ul>
                  @if (_pageState != 1) {
                    <div>
                      <button class="steps_buttons_class"
                        kendoButton
                        (click)="_onCancel()">
                        <img class="backimage"
                          [src]="'/assets/menu/'+ _theme +'/close-schedule-report-icon-green.svg'" />
                          <span>close</span>
                        </button>
                        @if (canAccess(_permissionScope, 'create')) {
                          <button class="steps_buttons_class"
                            kendoButton
                            [disabled]="_pageState == 4 ? true : false"
                            (click)="_onSave('saveAndCopy')">
                            <img class="backimage"
                              [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                              <span>save & Copy</span>
                            </button>
                          }
                          @if (canAccess(_permissionScope, 'create')) {
                            <button class="steps_buttons_class"
                              kendoButton
                              [disabled]="_pageState == 4 ? true : false"
                              (click)="_onSave('saveAndNew')">
                              <img class="backimage"
                                [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                                <span>save & New</span>
                              </button>
                            }
                            <button class="steps_buttons_class"
                              kendoButton
                              [disabled]="_pageState == 4 ? true : false"
                              (click)="_onSave('saveAndClose')">
                              <img class="backimage"
                                [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                                <span>save & Close</span>
                              </button>
                              <button class="steps_buttons_class"
                                kendoButton
                                [disabled]="_pageState == 4 ? true : false"
                                (click)="_onSave('save')">
                                <img class="backimage"
                                  [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                                  <span>save</span>
                                </button>
                              </div>
                            }
                          </div>
                        </div>
                        <div class="col-12">
                          <div class="formsMenuSeparator"></div>
                        </div>
                      </div>
                      <!-- Popup Content -->
                      <div class="row row_padding">
                        <fieldset class="col-12" [class.col-6-imp]="_pageState == 1 || _pageState == 2 || _pageState == 3 || _pageState == 4 || _currentUser.isEnterprise">
                          <!-- LBL_ConditionId Control -->
                          @if (getAuthByLabel('LBL_ConditionId')?.canView) {
                            <div KendoToolTip
                              class="form-group from_but_container special_style_formgroup margin-top-10">
                              <label for="conditionIdd" class="control-label">
                                {{getLabel("LBL_ConditionId")?.currentText}}
                              </label>
                              <input #kendo_BarcodeGen_Condition_ConditionId
                                type="text"
                                [class.ViewModeDisabledControl]="_pageState == 1"
                                class="k-textbox writebox min-width-0 newFormControlWidth"
                                [placeholder]="$safeNavigationMigration(getLabel('LBL_ConditionId')?.currentText)"
                                formControlName="conditionId"
                                id="conditionIdd"
                                formControl="conditionId"
                                (keyup.enter)="_NumberSubmitted()"
                                (keydown.Tab)="_NumberSubmitted()"
                                [attr.disabled]="(_pageState == 2 || _pageState == 3 || _pageState == 5) ? null : 'disabled'"
                                [disabled]="(_pageState == 2 || _pageState == 3 || _pageState == 5) ? false : true"
                                required />
                                <a title="Generate Barcode"
                                  [class.ViewModeHiddenElement]="_pageState == 1 || _pageState == 4"
                                  class="cursor-pointer"
                                  (click)="_generateBarCode()">
                                  <img class="searchIcon"
                                    [src]="'/assets/menu/'+ _theme +'/auto-generate-icon.svg'" />
                                  </a>
                                  <a title="Edit {{getLabel('LBL_ConditionId')?.currentText}}"
                                    [class.editfieldsIconvisible]="_pageState == 4"
                                    class="editFieldsIcon"
                                    (click)="_openRenameForm('LBL_ConditionId', true)">
                                    <img class="searchIcon"
                                      [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" />
                                    </a>
                                    <!--Barcode-->
                                    @if (_pageState == 3) {
                                      <app-barcode-print [page]="_page" [BarcodeValue]="_form.controls['conditionId'].value"></app-barcode-print>
                                    }
                                    <!--Barcode End-->
                                  </div>
                                }
                                <!-- LBL_ConditionDescription Control -->
                                @if (getAuthByLabel('LBL_ConditionDescription')?.canView) {
                                  <div KendoToolTip
                                    class="form-group special_style_formgroup">
                                    <label for="descriptionn" class="control-label">
                                      {{getLabel("LBL_ConditionDescription")?.currentText}}
                                    </label>
                                    <input #kendo_ConditionDescription
                                      type="text"
                                      [class.ViewModeDisabledControl]="_pageState == 1"
                                      class="k-textbox writebox min-width-0 newFormControlWidth"
                                      [placeholder]="$safeNavigationMigration(getLabel('LBL_ConditionDescription')?.currentText)"
                                      id="descriptionn"
                                      formControlName="description"
                                      [attr.disabled]="(getAuthByLabel('LBL_ConditionDescription')?.canEdit && (_pageState == 2 || _pageState == 3 || _pageState == 5)) ? null : 'disabled'"
                                      [disabled]="(getAuthByLabel('LBL_ConditionDescription')?.canEdit && (_pageState == 2 || _pageState == 3 || _pageState == 5)) ? false : true"
                                      [attr.required]="getLabel('LBL_ConditionDescription')?.isRequired ? 'required' : null"
                                      [required]="getLabel('LBL_ConditionDescription')?.isRequired ? 'required' : null"
                                      [ngClass]="{'bordered': $safeNavigationMigration(getLabel('LBL_ConditionDescription')?.isRequired)}" />
                                      <a title="Edit {{getLabel('LBL_ConditionDescription')?.currentText}}"
                                        [class.editfieldsIconvisible]="_pageState == 4"
                                        class="editFieldsIcon"
                                        (click)="_openRenameForm('LBL_ConditionDescription')">
                                        <img class="searchIcon"
                                          [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" />
                                        </a>
                                      </div>
                                    }
                                  </fieldset>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- Tabs and Fields -->
                          <div class="example-wrapper">
                            <div class="row no_row_margin">
                              <div [ngClass]="{'col-md-8': !_currentUser.isEnterprise,'col-md-12':_currentUser.isEnterprise}"
                                class="responsive_style numericboxtab" [class.ossystem]="_isOs" #kendo_tabstrip_wrapper>
                                @if ((_dataTabs && _dataTabs.length > 1) || _currentUser.isEnterprise) {
                                  <kendo-tabstrip (tabSelect)="_onTabSelect($event)" [tabPosition]="_kendoTabStripPosition"
                                    #kendo_tabstrip>
                                    <!-- Accounts Tab -->
                                    @if (_currentUser && _currentUser.isEnterprise) {
                                      <kendo-tabstrip-tab
                                        #accountTab title="Accounts"
                                        [selected]="_currentUser && _currentUser.isEnterprise">
                                        <ng-template kendoTabContent>
                                          <div class="greytabtop menumobilecontainer">
                                            <img class="mobiletabIcon"
                                              (click)="_mobileMenuToggle()"
                                              [src]="'/assets/menu/'+ _theme +'/fields-menu-icon.svg'" />
                                            </div>
                                            <div class="tabcontent tabWizGridInside accountTab"
                                              [class.active]="_addClassActive">
                                              <asap-account-sites-selection
                                                [class.ViewModeDisabledControl]="_pageState == 1"
                                                [disabled]="_pageState == 1"
                                                [selectedAccounts]="_selectedAccounts"
                                                [enableSiteSelection]="false"
                                                [resolver]="_getAccounts"
                                                (onRowSelectionChanges)="_onAccountRowSelectionChanges($event)">
                                              </asap-account-sites-selection>
                                            </div>
                                          </ng-template>
                                        </kendo-tabstrip-tab>
                                      }
                                      @for (tab of _dataTabs; track tab) {
                                        <!-- Custom Tab -->
                                        @if (tab.isCustom) {
                                          <kendo-tabstrip-tab [title]="tab.name"
                                            [disabled]="!_tabEnabled && _currentUser.isEnterprise"
                                            [selected]="_dataTabs.indexOf(tab) == 1">
                                            <ng-template kendoTabContent>
                                              <div class="tabcontent">
                                                <fieldset class="contenttabstyle margin-top-10">
                                                  <asap-custom-fields-form [customFields]="_customFields[tab.id]"
                                                    [pageState]="_pageState"
                                                    [accounts]="_selectedAccountIds"
                                                    [formName]="_entity"
                                                    [page]="_page"
                                                    [invalidSubmit]="_invalidSubmit"
                                                    (customFieldsValue)="_customFieldsValueChanges($event, tab.id)"
                                                    (customFieldsDeleteValue)="_removeCustomField($event)"
                                                    (customFieldsEditValue)="_openCustomRenameForm($event, tab.id)"
                                                    (customFieldsStatus)="formStatus($event)"
                                                    (customForm)="getCustomForm($event)"
                                                    [_customFieldsValue]="_customFieldsValue">
                                                  </asap-custom-fields-form>
                                                  <div class="form-group special_style_formgroup">
                                                    <button kendobutton
                                                      class="addNewFieldButton k-button"
                                                      (click)="_addNewField(tab.id)">
                                                      <img class="backimage"
                                                        src="/assets/menu/enterprise/add-icon-green.svg" />
                                                        <span>Add New Field</span>
                                                      </button>
                                                    </div>
                                                    <div class="form-group special_style_formgroup">
                                                      <button kendobutton
                                                        class="addNewFieldButton k-button"
                                                        (click)="_deactivateTab(tab.id, _page)">
                                                        <img class="backimage"
                                                          src="/assets/menu/enterprise/add-icon-green.svg" />
                                                          <span>Deactivate Tab</span>
                                                        </button>
                                                      </div>
                                                    </fieldset>
                                                  </div>
                                                </ng-template>
                                              </kendo-tabstrip-tab>
                                            }
                                          }
                                        </kendo-tabstrip>
                                      }
                                    </div>
                                    <div class="col-4 col-lg-4 col-xl-4 responsive_style">
                                      @if (!_currentUser.isEnterprise) {
                                        <div
                                          class="borderedNotesContainer">
                                          <note #note
                                            [_pageState]="_pageState"
                                            [_model]="_model"
                                            [_page]="_page">
                                          </note>
                                        </div>
                                      }
                                    </div>
                                  </div>
                                  <div class="row no_row_margin">
                                    <div class="col-12">
                                      <button kendobutton
                                        class="addNewtabButton k-button"
                                        (click)="_addNewTab()">
                                        <img class="backimage"
                                          src="/assets/menu/enterprise/add-icon-green.svg" /><span>Add New Tab</span>
                                        </button>
                                      </div>
                                    </div>
                                    <div class="row no_row_margin">
                                      <div class="col-12">
                                        <button kendobutton
                                          class="reorderTabButton k-button"
                                          (click)="_reorderingtabs()">
                                          <img class="backimage"
                                            src="/assets/menu/enterprise/reorder-tabs-icon.svg" /><span>reorder tabs</span>
                                          </button>
                                        </div>
                                      </div>
                                      <div class="row no_row_margin">
                                        <div class="col-12">
                                          <p class="tabsMap" [class.ViewModeHiddenElement]="_pageState != 4">
                                            Notes:
                                          </p>
                                          @if (_dataTabs && _dataTabs.length > 1) {
                                            <p class="tabsMap">
                                              Tabs with <span>*</span> contains Mandatory fields
                                            </p>
                                          }
                                          <p class="tabsMap" [class.ViewModeHiddenElement]="_pageState != 4">
                                            You can Drag and Drop Fields to reorder by clicking on this image
                                            <img class="reorder_image"
                                              [src]="'/assets/menu/'+ _theme +'/reordering-icon.svg'" />
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                      <!-- Validation Summary -->
                                      <div class="row">
                                        <div class="col-12">
                                          @if (_invalidForm) {
                                            <asap-forms-validation-summary
                                              [form]="_form"
                                              [page]="_page"
                                              [customValidation]="_customValidation"
                                              [additionalErrors]="_additionalErrors">
                                            </asap-forms-validation-summary>
                                          }
                                        </div>
                                      </div>
                                    </form>
                                    @if (_editFormActive || _orderingTabsForm || _deactivatedFieldsForm || _isEditForms) {
                                      <div class="k-overlay"
                                      ></div>
                                    }
                                    @if (_isDialiog) {
                                      <asap-dialog-layout
                                        [data]="_dialogModel"
                                        [componentName]="_dialogComponentName"
                                        (closeDialog)="_closeDialog($event)">
                                      </asap-dialog-layout>
                                    }
                                  </kendo-window>
                                }
                                @if (_editFormActive) {
                                  <kendo-window
                                    [resizable]="false"
                                    title="{{ _isCustomfieldsFormValue ? 'Add Custom Fields' : (_isAddTabFormValue ? 'Add New Tabs' : (_isRenameFormValue ? 'Edit Record' : '')) }}"
                                    (close)="_closeCustomFields()"
                                    class="customFieldsWindow">
                                    <asap-custom-fields [accounts]="_selectedAccountIds"
                                      [tabGroup]="_selectedTabId"
                                      [labelId]="_selectedLabelId"
                                      [labelObjectCode]="_selectedLabelObjectCode"
                                      [formName]="_entity"
                                      [page]="_page"
                                      [isCustomfieldsForm]="_isCustomfieldsFormValue"
                                      [isCustomtabsForm]="_isAddTabFormValue"
                                      [isRenameForm]="_isRenameFormValue"
                                      [language]="_language"
                                      [isRenameCustomForm]="_isRenameCustomFormValue"
                                      [isRenameLabel]="_isRenameLabel"
                                      [isMandatory]="_isMandatory"
                                      (closePopup)="ClosePopup($event)"
                                      [permissionScope]="_permissionScope">
                                    </asap-custom-fields>
                                  </kendo-window>
                                }
                                @if (_orderingTabsForm) {
                                  <kendo-window
                                    title="Tab Reordering"
                                    (keydown.enter)="$event.preventDefault()"
                                    (close)="_closeOrderingTabsForm()">
                                    <div class="row no_row_margin margin-top-30">
                                      @if (false) {
                                        <div class="col-12 margin-top-10">
                                          <div class="form-group">
                                            <label for="itemType" class="control-label">Tab 1</label>
                                            <kendo-combobox [data]="_dataTabsSelected"
                                              [suggest]="true"
                                              [valueField]="'name'"
                                              placeholder="Accounts/Sites"
                                              class="newFormControlWidth disabled">
                                            </kendo-combobox>
                                          </div>
                                        </div>
                                      }
                                      @for (item of _dataTabs ; track item; let i = $index) {
                                        <div class="col-12 margin-top-10">
                                          <div class="form-group">
                                            <label for="itemType" class="control-label">Tab {{ i + 1 }}</label>
                                            <kendo-combobox [data]="_dataTabsSelected"
                                              [suggest]="true"
                                              [textField]="'name'"
                                              [valueField]="'name'"
                                              [placeholder]="item.name"
                                              required
                                              class="bordered newFormControlWidth"
                                              (valueChange)="_comboValueChange($event,i)">
                                            </kendo-combobox>
                                          </div>
                                        </div>
                                      }
                                    </div>
                                    <div class="row no_row_margin">
                                      <div class="col-12">
                                        <button kendoButton
                                          class="steps_buttons_class"
                                          (click)="_onSaveTabOrdering()">
                                          <img class="backimage"
                                            [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                                            <span>save & Close</span>
                                          </button>
                                        </div>
                                      </div>
                                    </kendo-window>
                                  }
                                  @if (_isEditForms) {
                                    <asap-edit-forms
                                      (close)="_onCloseEditForms($event)"
                                      (saved)="_closeCustomFields()"
                                      [page]="_page"
                                      [permissionScope]="_permissionScope">
                                    </asap-edit-forms>
                                  }
                                  @if (_deactivatedFieldsForm) {
                                    <kendo-window
                                      title="Deactivated Fields"
                                      (close)="_closeInactiveFields()">
                                      <div class="row no_row_margin margin-top-30">
                                        <div class="col-12 margin-top-10">
                                          <kendo-grid [data]="_deactivatedFieldsGridData" [scrollable]="'none'">
                                            <kendo-grid-column field="name" title="Fields Name">
                                            </kendo-grid-column>
                                            <kendo-grid-column field="formTab.name" title="Tab Name">
                                            </kendo-grid-column>
                                            <kendo-grid-column field="createdOn" title="Added Date" type="date">
                                              <ng-template kendoGridCellTemplate let-dataItem>
                                                {{dataItem.createdOn | dateFormat}}
                                              </ng-template>
                                            </kendo-grid-column>
                                            <kendo-grid-column field="lastUpdatedOn"
                                              title="Deactivation Date"
                                              type="date">
                                              <ng-template kendoGridCellTemplate let-dataItem>
                                                {{dataItem.lastUpdatedOn | dateFormat}}
                                              </ng-template>
                                            </kendo-grid-column>
                                            <kendo-grid-column field="Command" title="Command">
                                              <ng-template kendoGridCellTemplate let-dataItem>
                                                <div class="action-button action-button-deactivate"
                                                  (click)="_reactivateField(dataItem)">
                                                  <div class="action-button-icon">
                                                    <img src="/assets/menu/enterprise/deactivate-icon.svg" />
                                                  </div>
                                                  <div class="edit-icon-text">Reactivate</div>
                                                </div>
                                              </ng-template>
                                            </kendo-grid-column>
                                          </kendo-grid>
                                        </div>
                                      </div>
                                    </kendo-window>
                                  }
